<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <rect width="12.75" height="8.75" x="3.625" y="5.625" stroke="currentColor" stroke-width="1.25" rx="1.375" />
        <circle cx="10" cy="10" r="2.375" stroke="currentColor" stroke-width="1.25" />
        <circle cx="14" cy="8" r=".5" fill="currentColor" stroke="currentColor" />
    </svg>
</template>